<template>
  <div class="col-lg-10" style="margin-top: 20px; margin-left: -20px;">
    <br />
    <el-form :inline="true" size="mini" :model="search" class="demo-form-inline" style="margin: 0 -15px;">
      <el-form-item label="出发日期">
        <el-date-picker v-model="search.ChuFaRiQi_S" type="date" placeholder="出发日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="至">
        <el-date-picker v-model="search.ChuFaRiQi_E" type="date" placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="关键字">
        <el-input v-model="search.Keyword" placeholder="出发地、到达地"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="reload">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="row" v-loading="showLoading">
      <div class="JY-items-list" v-for="item in items" :key="item.ID">
        <a href="javascript:;" @click="openDetail(item)">
          <h3>
            <el-tag size="mini" type="danger" v-if="item.IsExpired">已过期</el-tag>
            <el-tag size="mini" v-if="item.HasPrice">已报价:￥{{formatNumber(item.HasPrice)}}</el-tag>
            <el-tag size="mini" type="success" v-if="item.PingTaiBaoJia">
              平台报价:￥{{formatNumber(item.PingTaiBaoJia)}}
            </el-tag>
            {{item.SourceGoodsNo}} {{item.ChuFaDi}} - {{item.DaoDaDi}}
            <span class="pull-right">{{item.CreateTime}}</span>
          </h3>
        </a>
        <div>
          出发时间-到达时间：
          <span style="font-weight: bold; color: #007bff">{{item.ChuFaRiQi}} - {{item.DaoDaRiQi}}</span>
        </div>
        <div>
          订单有效期：
          <span
            style="font-weight: bold; color: #000"
          >{{item.YouXiaoQiStart}} - {{item.YouXiaoQiEnd}}</span>
        </div>
        <div v-if="item.HuoWuZhongLiang">
          货物重量：
          <span style="font-weight: bold; color: #e6a23c">{{item.HuoWuZhongLiang}}</span>
        </div>
        <div>
          货物种类：
          <span style="font-weight: bold; color: #000">{{item.GoodsType}}</span>
        </div>
        <div>
          报价方式：
          <span style="font-weight: bold; color: #000">{{item.BaoJiaLeiXing==0?'按吨':'按车'}}</span>
        </div>
        <br />
        <div class v-if="item.BaoJia">
          报价详情:
          <template v-if="Array.isArray(item.BaoJia.BaoJiaJson)">
            <div
              v-for="baojia in item.BaoJia.BaoJiaJson"
              :key="baojia.ID"
              style="display: block; margin-bottom: 4px;"
            >
              <el-tag
                v-if="item.BaoJiaLeiXing==1"
                size="mini"
              >车型:{{baojia.DisplayCarModelID}},每车:{{baojia.UnitPrice}}元,能运{{baojia.CarCount}}车,可接受油卡金额:{{baojia.YouKaPrice}},{{baojia.HasBill?'提供发票':'不提供发票'}},{{baojia.TaxPoint?('税点:'+baojia.TaxPoint):''}}</el-tag>
            </div>
          </template>
          <template v-else>
            <el-tag>每吨单价:{{item.BaoJia.BaoJiaJson.UnitPrice}},车型:{{item.BaoJia.BaoJiaJson.DisplayCarModelID}},每车{{item.BaoJia.BaoJiaJson.CarVolume}}吨,能运{{item.BaoJia.BaoJiaJson.CarCount}},可接受油卡金额:{{item.BaoJia.BaoJiaJson.YouKaPrice}},{{item.BaoJia.BaoJiaJson.HasBill?'提供发票':'不提供发票'}},{{item.BaoJia.BaoJiaJson.TaxPoint?('税点:'+item.BaoJia.BaoJiaJson.TaxPoint):''}}</el-tag>
          </template>
        </div>
      </div>
    </div>
    <div class="row mt10">
      <el-pagination
        @current-change="loadMore"
        background
        :page-size="search.PageSize"
        layout="total, prev, pager, next"
        :total="itemCount"
      ></el-pagination>
    </div>
    <el-dialog title="我的报价" width="500px" :visible.sync="priceDialogVisible">
      <div v-if="selectedGood.BaoJiaLeiXing==0" style="margin-top: 30px;">
        <el-form size="mini" class="demo-form-inline" label-width="120px">
          <el-form-item label="每吨单价">
            <el-input
              type="number"
              :disabled="selectedGood.GoodPrice!=null"
              v-model="baoJiaJson.UnitPrice"
              placeholder="每吨单价"
            ></el-input>元
          </el-form-item>
          <!-- <el-form-item label="车型">
            <el-select :disabled="selectedGood.GoodPrice!=null"
              v-model="baoJiaJson.CarModelID"
              filterable
              placeholder="选择车型">
              <el-option
                v-for="item in carModels"
                :key="item.ID"
                :label="item.Name"
                :value="item.ID"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="能运吨数">
            <el-input
              type="number"
              :disabled="selectedGood.GoodPrice!=null"
              v-model="baoJiaJson.CarVolume"
              placeholder="能运吨数"
            ></el-input>吨
          </el-form-item>
          <!-- <el-form-item label="能运多少车">
            <el-input
              type="number"
              :disabled="selectedGood.GoodPrice!=null"
              v-model="baoJiaJson.CarCount"
              placeholder="能运多少车"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="油卡金额/车">
            <el-input
              type="number"
              :disabled="selectedGood.GoodPrice!=null"
              v-model="baoJiaJson.YouKaPrice"
              placeholder="油卡金额/车"
            ></el-input>元
          </el-form-item>
          <el-form-item label="是否提供专票">
            <el-switch
              active-text="提供"
              inactive-text="不提供"
              :disabled="selectedGood.GoodPrice!=null"
              v-model="baoJiaJson.HasBill"
            ></el-switch>
          </el-form-item>
          <el-form-item v-if="baoJiaJson.HasBill" label="税点">
            <el-select
              :disabled="selectedGood.GoodPrice!=null"
              v-model="baoJiaJson.TaxPoint"
              filterable
              placeholder="选择税点">
              <el-option v-for="item in TaxPoints" :key="item.k" :label="item.v" :value="item.k"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="其他">
            <el-input
              type="text"
              :disabled="selectedGood.GoodPrice!=null"
              v-model="baoJiaJson.Description"
              placeholder="其他描述"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-else style="padding-top: 20px; padding-left: 0px; text-align: left !important;">
        <el-form class="demo-form-inline" size="mini">
          <el-form-item
            v-for="item in baoJiaJson"
            :key="item.CarModelID"
            :label="item.DisplayCarModelID+'(需要'+item.CarNum+'辆)'"
          >
            <br />
            <br />每车
            <el-input
              style="width:180px !important; margin-bottom:6px;"
              :disabled="selectedGood.GoodPrice!=null"
              v-model="item.UnitPrice"
              @change="changeCarNumber(item)"
              type="number"
              placeholder="单价"
            ></el-input>元 能运
            <el-input
              style="width:180px !important"
              :disabled="selectedGood.GoodPrice!=null"
              v-model="item.CarCount"
              @change="changeCarNumber(item)"
              type="number"
              placeholder="车辆数"
            ></el-input>车
            <br />可接受油卡金额
            <el-input
              style="width:340px !important"
              type="number"
              :disabled="selectedGood.GoodPrice!=null"
              v-model="item.YouKaPrice"
              placeholder="可接受油卡金额"
            ></el-input>元
          </el-form-item>
          <el-form-item label="是否提供专票">
            <el-switch
              active-text="提供"
              inactive-text="不提供"
              :disabled="selectedGood.GoodPrice!=null"
              v-model="baoJiaJson.HasBill"
            ></el-switch>
          </el-form-item>
          <el-form-item v-if="baoJiaJson.HasBill" label="税点">
            <el-select
              :disabled="selectedGood.GoodPrice!=null"
              v-model="baoJiaJson.TaxPoint"
              filterable
              placeholder="选择税点"
            >
              <el-option v-for="item in TaxPoints" :key="item.k" :label="item.v" :value="item.k"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="其他">
            <el-input
              style="width:87.5% !important;"
              type="text"
              :disabled="selectedGood.GoodPrice!=null"
              v-model="baoJiaJson.Description"
              placeholder="其他描述"
            ></el-input>
          </el-form-item>
          <el-form-item label="总价">￥{{formatNumber(baoJiaTotal||0)}}</el-form-item>
        </el-form>
      </div>
      <div class="center" v-if="selectedGood.GoodPrice==null">
        <el-checkbox v-model="inputAgree" style="padding-bottom: 20px;">查看并同意</el-checkbox>
        <a @click="openCondition" href="javascript:;">《报价协议》</a>
      </div>
      <div class="center" v-if="selectedGood.GoodPrice==null">
        <el-button :disabled="!inputAgree" @click="savePrice()" type="primary">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="订单详情" width="70%" top="1vh" :visible.sync="dialogVisible">
      <div style="position: absolute; right: 40px; bottom: 40px; z-index: 999;">
        <el-tag class="price" v-if="selectedGood.GoodPrice!=null" type="danger">您已报价</el-tag>
        <el-button
          v-if="selectedGood.IsLock!=1"
          @click="openPrice"
          type="primary"
        >{{selectedGood.GoodPrice!=null?'查看报价':'我要报价'}}</el-button>
        <el-tag v-else>订单已经锁定，不允许报价</el-tag>
      </div>
      <good-detail
        :hiddenInfo="true"
        :hiddenContract="true"
        :good="selectedGood"
        :images="selectedGoodImages"
      ></good-detail>
    </el-dialog>
    <el-dialog title="报价协议" :visible.sync="conditionDialogVisible" width="70%" center>
      <condition :id="conditionId"></condition>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../api";
import goodDetail from "../../components/goodDetail";
import condition from "../../components/condition";
import util from "../../libs/util";
export default {
  components: {
    goodDetail,
    condition
  },
  data() {
    return {
      conditionDialogVisible: false,
      conditionId: "",
      inputAgree: false,
      selectedGood: {},
      selectedGoodImages: [],
      showLoading: false,
      dialogVisible: false,
      priceDialogVisible: false,
      choosedOrderId: "",
      items: [],
      itemCount: 0,
      baoJia: {},
      baoJiaJson: {
        HasBill: false
      },
      TaxPoints: [
        {
          k: "0",
          v: "0%"
        },
        {
          k: "3",
          v: "3%"
        },
        {
          k: "6",
          v: "6%"
        },
        {
          k: "10",
          v: "10%"
        }
      ],
      baoJiaTotal: 0,
      carModels: [],
      search: {
        PageNo: 1,
        PageSize: 10,
        SortField: "createtime",
        SortBy: "desc"
      }
    };
  },
  methods: {
    formatNumber(n) {
      return util.getThousandNumber(n);
    },
    openCondition() {
      this.conditionId = "ee0b04b1-0059-4af7-9761-b730c8ba0218";
      this.conditionDialogVisible = true;
    },
    getDictionaries() {
      let _this = this;
      api.getDictionary({
          search: {
            IsEnabled: "",
            PageNo: 1,
            PageSize: 1000
          },
          tableName: "carModel"
        })
        .then(res => {
          _this.carModels = res.data.Data.Data;
        });
    },
    openPrice() {
      let _this = this;
      _this.priceDialogVisible = true;
    },
    savePrice() {
      this.$confirm("报价后不能修改报价, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
          this.doSavePrice();
        }).catch();
    },
    doSavePrice() {
      let _this = this;
      let total = 0;
      if (this.selectedGood.BaoJiaLeiXing == 0) {
        total =
          (_this.baoJiaJson.CarCount || 1) *
          (_this.baoJiaJson.UnitPrice || 0) *
          (_this.baoJiaJson.CarVolume || 0);
        _this.$set(_this.baoJiaJson, "Total", total);
      } else {
        total = _this.baoJiaTotal;
        _this.baoJiaJson.forEach(function(item) {
          item.Description = _this.baoJiaJson.Description;
          item.HasBill = _this.baoJiaJson.HasBill;
          item.TaxPoint = _this.baoJiaJson.TaxPoint;
          //item.YouKaPrice = _this.baoJiaJson.YouKaPrice;
        });
      }
      if (!total) {
        _this.$message({
          type: "warning",
          message: `请输入正确的报价`
        });
        return;
      }
      if (_this.selectedGood.BaoJiaLeiXing == 0) {
        if (_this.baoJiaJson.CarVolume && _this.baoJiaJson.CarCount) {
          var totalDun = _this.baoJiaJson.CarVolume * _this.baoJiaJson.CarCount;
          if (totalDun > _this.selectedGood.HuoWuZhongLiang) {
            _this.$message({
              type: "warning",
              message: `总吨不能大于${_this.selectedGood.HuoWuZhongLiang}`
            });
            return;
          }
        }
      }
      api.addOrUpdateSourceGoodsPrice({
          ID: _this.selectedGood.ID,
          CarList: _this.baoJiaJson,
          BaoJiaDun: _this.baoJiaJson
        })
        .then(res => {
          if (res.data.Succeed) {
            _this.selectedGood.GoodPrice = total;
            _this.$message({
              type: "success",
              message: `报价成功`
            });
            _this.priceDialogVisible = false;
            //_this.baoJiaJson.Total = 0
            //_this.baoJiaTotal = 0
          } else {
            _this.$message({
              type: "error",
              message: `报价失败，原因: ${res.data.Message}`
            });
          }
        });
    },
    loadItems() {
      let _this = this;
      _this.showLoading = true;
      api.searchSourceGoods(_this.search).then(res => {
        _this.showLoading = false;
        if (res.data.Succeed) {
          res.data.Data.Data.forEach(x => {
            if (x.BaoJia) {
              x.BaoJia.BaoJiaJson = JSON.parse(x.BaoJia.BaoJiaJson);
            }
          });
          _this.items = res.data.Data.Data;
          _this.itemCount = res.data.Data.totalItemCount;
        } else {
          _this.$message({
            message: res.data.Message,
            type: "error"
          });
        }
      });
    },
    reload() {
      this.search.PageNo = 1;
      this.loadItems();
    },
    loadMore(n) {
      this.search.PageNo = n;
      this.loadItems();
    },
    openDetail(item) {
      let _this = this;
      _this.showLoading = true;
      _this.baoJiaJson = {
        HasBill: false
      };
      api
        .getSourceGood({
          id: item.ID
        })
        .then(res => {
          _this.dialogVisible = true;
          _this.showLoading = false;
          _this.selectedGood = res.data.Data.Data;
          if (res.data.Data.BaoJia) {
            _this.baoJia = res.data.Data.BaoJia;
            _this.baoJiaTotal = res.data.Data.BaoJia.Total;
            _this.baoJiaJson = JSON.parse(_this.baoJia.BaoJiaJson);
            if (_this.selectedGood.BaoJiaLeiXing == 1) {
              if (_this.baoJiaJson[0]) {
                _this.baoJiaJson.HasBill = _this.baoJiaJson[0].HasBill == 1;
                //_this.baoJiaJson.YouKaPrice = _this.baoJiaJson[0].YouKaPrice;
                _this.baoJiaJson.TaxPoint = _this.baoJiaJson[0].TaxPoint;
                _this.baoJiaJson.Description = _this.baoJiaJson[0].Description;
              }
            } else {
              _this.baoJiaJson.HasBill = _this.baoJiaJson.HasBill == 1;
              _this.baoJiaJson.YouKaPrice = _this.baoJiaJson.YouKaPrice;
              _this.baoJiaJson.TaxPoint = _this.baoJiaJson.TaxPoint;
              _this.baoJiaJson.Description = _this.baoJiaJson.Description;
            }
          } else {
            if (_this.selectedGood.BaoJiaLeiXing == 1) {
              _this.baoJiaJson = _this.selectedGood.CarList;
            }
          }
          _this.selectedGoodImages = [];
          if (res.data.Data.Attachments) {
            res.data.Data.Attachments.forEach(item => {
              _this.selectedGoodImages.push({
                AttID: item.AttID,
                AttName: item.AttName,
                TypeName: item.TypeName,
                Url: process.env.BASE_API+'/Apps/JYJYManage/Preview/PreviewImage?id='+item.AttID
              });
            });
          }
        });
    },
    changeCarNumber() {
      var _this = this;
      var total = 0;
      _this.baoJiaJson.forEach(x => {
        if (x.UnitPrice) {
          total += parseFloat(x.UnitPrice || 0) * parseInt(x.CarCount || 0);
        }
      });
      _this.baoJiaTotal = total;
    }
  },
  mounted() {
    this.baoJiaJson.Total = 0;
    this.baoJiaTotal = 0;
    this.loadItems();
    this.getDictionaries();
  }
};
</script>

<style scoped>
.el-input {
  width: 120px !important;
}
#btn_search {
  margin-left: 10px;
}
.mt10 {
  margin-top: 10px;
}
.JY-items-list,
.JY-items-search {
  width: 100%;
}
.hasPrice {
  color: #409eff;
  float: left;
  display: inline-block;
  margin-top: 3px;
  margin-right: 10px;
}
.status0 {
  color: #e6a23c;
}
.status1 {
  color: #67c23a;
}
.status2 {
  color: #f56c6c;
}
.demo-form-inline .el-input,
.demo-form-inline .el-select {
  width: 85% !important;
}
.center {
  text-align: center;
}
.sp-form {
  border-bottom: 1px solid #fdfdfd;
}
.sp-form h4,
h4 {
  font-size: 18px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Driver/DriverSearch.vue